<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">Cập nhật thông tin luồng</h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên luồng" prop="flowName">
              <el-input
                v-model="form.flowName"
                placeholder="Tên luồng"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="150"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Mã" prop="flowCode">
              <el-input
                v-model="form.flowCode"
                placeholder="Mã"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Loại quy trình" prop="flowType">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.flowType"
                placeholder="Loại quy trình"
                size="medium"
                filterable
                clearable
                :disabled="isEdit"
                @change="flowTypeChanged"
              >
                <el-option
                  v-for="item in flowTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Cấp quy trình" prop="deptId">
              <template slot="label">
                <span class="label-input">
                  Cấp quy trình
                  <el-tooltip
                    content="Cây danh mục đơn vị"
                    placement="top"
                    effect="dark"
                    v-if="!isEdit"
                  >
                    <i
                      class="fas fa-cog advance-search color__cyan clickable"
                      @click="isOpenSelectDepartmentDialog = true"
                    ></i>
                  </el-tooltip>
                </span>
              </template>

              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.deptId"
                placeholder="Cấp quy trình"
                size="medium"
                filterable
                clearable
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in departments"
                  :key="item.id"
                  :label="`${item.deptName} - ${item.identityCode} (${item.parentName})`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="250"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="Mặc định" prop="isDefault">
              <el-checkbox
                :border="false"
                v-model="form.isDefault"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="Hoạt động" prop="status">
              <el-checkbox
                :border="false"
                v-model="form.status"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>

          <!--          <el-col :span="8" v-if="isIncomingFlow">-->
          <!--            <el-form-item label="Ẩn ý kiến VT" prop="hideVtComments">-->
          <!--              <el-checkbox-->
          <!--                :border="false"-->
          <!--                v-model="form.hideVtComments"-->
          <!--                class="style-fullWidth"-->
          <!--              >-->
          <!--              </el-checkbox>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>

        <common-select-department-dialog
          :isOpen="isOpenSelectDepartmentDialog"
          :title="'Chọn đơn vị'"
          v-if="isEnableSelectDepartmentDialog"
          @closed="isEnableSelectDepartmentDialog = false"
          @closeDialog="isOpenSelectDepartmentDialog = false"
          @change="publisherDepartmentChange"
        >
        </common-select-department-dialog>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import cauHinhLuongUtils from "../../../services/cauhinhluong/cauHinhLuongUtils";
import departmentService from "../../../services/departmentService";
import h from "../../../services/h";
import utils from "../../../services/utils";
import CommonSelectDepartmentDialog from "../../common/commonSelectDepartmentDialog";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "vb-flow-detail-dialog",
  components: { CommonSelectDepartmentDialog, CustomDialog },
  props: ["isOpen", "vbFlowForm"],
  data() {
    return {
      form: {
        flowName: null,
        flowCode: null,
        flowType: null,
        deptId: null,
        note: null,
        isDefault: null,
        status: null,
        // hideVtComments: null
      },
      rules: {
        flowName: null,
        flowCode: null,
        flowType: null,
        deptId: null,
        note: null,
        isDefault: null,
        status: null,
        // hideVtComments: null
      },
      flowTypeOptions: null,
      departments: [],

      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,
    };
  },

  computed: {
    isEdit() {
      return !!this.vbFlowForm.deptId;
    },
    isIncomingFlow() {
      return this.form.flowType === constants.FLOW_TYPE.VB_DEN;
    },
  },

  watch: {
    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    },
  },

  created() {
    this.initComponent();
  },

  methods: {
    flowTypeChanged() {
      //reset lại giá trị "ẩn comment văn thư" khi thay đổi kiểu luồng;
      // this.form.hideVtComments = false;
    },

    initComponent() {
      this.initValidationRules();
      this.bindDataToForm();
      this.initFlowTypeOptions();
      this.loadDepartments();
    },

    loadDepartments() {
      return departmentService
        .findAll({ sort: "path,asc" })
        .then((response) => (this.departments = response.data));
    },

    publisherDepartmentChange({ selectedDepartment }) {
      let department = selectedDepartment;
      this.form.deptId = department ? department.id : null;
      this.isOpenSelectDepartmentDialog = false;
    },

    initFlowTypeOptions() {
      this.flowTypeOptions = h.collect(
        [constants.FLOW_TYPE.VB_DEN, constants.FLOW_TYPE.VB_DI],
        (flowType) => {
          return {
            value: flowType,
            label: cauHinhLuongUtils.getFlowTypeName(flowType),
          };
        }
      );
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    submit() {
      return this.validateForm().then(() => {
        this.$emit("submit", { form: this.convertToSubmitForm() });
      });
    },

    convertToSubmitForm() {
      return {
        flowName: this.form.flowName,
        flowCode: this.form.flowCode,
        flowType: this.form.flowType,
        deptId: this.form.deptId,
        note: this.form.note,
        isDefault: this.form.isDefault ? constants.TRUE : constants.FALSE,
        status: this.form.status
          ? constants.STATUS_.ACTIVE
          : constants.STATUS_.DEACTIVE,
        // hideVtComments: this.form.hideVtComments
        //   ? constants.TRUE
        //   : constants.FALSE
      };
    },

    bindDataToForm() {
      this.form.flowName = this.vbFlowForm.flowName;
      this.form.flowCode = this.vbFlowForm.flowCode;
      this.form.flowType = this.vbFlowForm.flowType;
      this.form.deptId = this.vbFlowForm.deptId;
      this.form.note = this.vbFlowForm.note;
      this.form.isDefault = this.vbFlowForm.isDefault === constants.TRUE;
      //trong TH tạo mới thì default là hoạt động;
      this.form.status = this.isEdit
        ? this.vbFlowForm.status === constants.STATUS_.ACTIVE
        : true;
      // this.form.hideVtComments =
      //   this.vbFlowForm.hideVtComments === constants.TRUE;
    },

    initValidationRules() {
      let defaultRequiredConstrains = utils.buildRequiredValidationConstrains();
      this.rules.flowName = [defaultRequiredConstrains];
      this.rules.flowType = [defaultRequiredConstrains];
      // this.rules.deptId = [defaultRequiredConstrains];
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/vb-flow-detail-dialog.vue